
import React, { Suspense } from "react"

import { useProfile } from "../../common/useProfile";
import Service from "../../../util/Service";
import { CircularProgress, IconButton, Tooltip, Typography } from "@mui/material";
import HtmlContent from "../../util/HtmlContent";
import EditIcon from '@mui/icons-material/Edit';
import { ExitToApp, Save } from "@mui/icons-material";
import { ShowWait } from "../../home/Home";
const VeryEditor2 = React.lazy(() => import('../../common/EditorVery/VeryEditor2'));

export default function MinhaPagina() {
    const prof = useProfile();

    //const refDiv = React.useRef();
    const ref = React.useRef();
    const [pagina, setPagina] = React.useState();
    const [html, setHtml] = React.useState('');
    const [wait, setWait] = React.useState(true);
    const [edit, setEdit] = React.useState(false);

    React.useEffect(() => {

        if (prof.profile) {
            buscaPagina(prof.profile.id)
        }
    }, [prof.profile]);

    function buscaPagina(p) {
        setWait(true);
        Service.GET("/api/paginaHtml/buscaPorNome/" + p).then(r => {
            console.log(r);
            if (r && r.length > 0) setPagina(r[0]);
            else setPagina();
            setWait(false)
        })
    }

    function handleSalva() {
        const html = ref.current.getHtml();
        
        let dado = {
            nome:      prof.profile.id,
            titulo:    prof.profile.nome,
            descricao: prof.profile.email,
            pagina: html,
            rules: ['paginaPessoal']
        }
        if (pagina) {
            dado.id = pagina.id;
        }
        Service.POST("/api/security/paginaHtml", dado).then(r => {
            console.log(r);
            setPagina(r);
        })
    }
    function handleEdit() {
        console.log('>>>handleEdit<<', edit);
        setEdit(true);
    }

    if (wait) {
        return (
            <center style={{ marginTop: '10%' }}>
                <CircularProgress color="inherit" />
            </center>
        )
    }
    if (!pagina) {
        return (
            <div style={{ padding: '5px', marginTop: '15px' }}>
                <Typography variant="h4">Voce pode criar sua pagina personalisando editando o componente abaixo:</Typography>
                <Suspense fallback={<ShowWait />}>
                    <VeryEditor2
                        html={pagina ? pagina.pagina : ''} ref={ref}
                        style={{ padding: 4, border: '2px solid black', overflow: 'auto', height: '450px' }}
                        action={
                            <React.Fragment>
                                <Tooltip title="Salvar pagina">
                                    <IconButton aria-label="edit" color="primary"
                                        onClick={handleSalva}
                                    >
                                        <Save />
                                    </IconButton>
                                </Tooltip>
                            </React.Fragment>
                        }
                        saveAction={handleSalva}
                    />
                </Suspense>
            </div>
        )
    }
    if (edit === true) {
        return (
            <div style={{ padding: '5px' }}>
                <div className='edit'>
                    <Tooltip title="Sair da edição">
                        <IconButton aria-label="edit" color="primary"
                            onClick={() => setEdit(false)}
                        >
                            <ExitToApp />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Salvar pagina">
                        <IconButton aria-label="edit" color="primary"
                            onClick={handleSalva}
                        >
                            <Save />
                        </IconButton>
                    </Tooltip>
                </div>
                <Suspense fallback={<ShowWait />}>
                    <VeryEditor2
                        html={pagina.pagina}
                        ref={ref}
                        style={{
                            padding: 4, border: '2px solid black', overflow: 'auto', 
                            maxHeight: '90vh',
                            height:"70vh"
                        }}
                        saveAction={handleSalva}
                    />
                </Suspense>
            </div>
        )
    }
    return (
        <div>
            <div className='edit'>
                <Tooltip title={"Editar componente"}>
                    <IconButton aria-label="edit" color="primary" onClick={handleEdit}>
                        <EditIcon />
                    </IconButton>
                </Tooltip>
            </div>
            <HtmlContent htmlString={pagina.pagina} edit={false} />
        </div>
    )
}